var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIniciarTransaccion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 320,
    height: 108,
    viewBox: "0 0 320 108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Uni\\xF3n_249",
    x: 254,
    y: 25,
    width: 50,
    height: 49,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Uni\\xF3n_250",
    x: 16,
    y: 25,
    width: 50,
    height: 49,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Uni\\xF3n_251",
    x: 117,
    y: 12,
    width: 87,
    height: 87,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.09
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-iniciar-transaccion"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 108
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iniciar-transaccion",
    clipPath: "url(#clip-iniciar-transaccion)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16529",
    "data-name": "Grupo 16529",
    transform: "translate(-1 -28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1311",
    "data-name": "Trazado 1311",
    d: "M61.172,0H247.106c33.785,0,61.172,22.8,61.172,50.922s-27.388,50.922-61.172,50.922H61.172C27.388,101.845,0,79.046,0,50.922S27.388,0,61.172,0Z",
    transform: "translate(315.28 132.423) rotate(-180)",
    fill: "#c38975",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16425",
    "data-name": "Grupo 16425",
    transform: "translate(644.396 -136.183) rotate(69)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_444",
    "data-name": "Elipse 444",
    transform: "translate(20.983 510.752)",
    fill: "none",
    stroke: "#c38975",
    strokeWidth: 1,
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.285,
    cy: 2.285,
    r: 2.285,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.285,
    cy: 2.285,
    r: 1.785,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_587",
    "data-name": "L\\xEDnea 587",
    x1: 9.9,
    y1: 6.092,
    transform: "translate(24.03 501.808)",
    fill: "none",
    stroke: "#c38975",
    strokeWidth: 1,
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1308",
    "data-name": "Trazado 1308",
    d: "M-19601-6860.665c5.531,15,43.066,27.5,109.322,27.5s112.209-8.5,123.678-27.5",
    transform: "translate(19645.5 6930.666)",
    fill: "none",
    stroke: "#00875a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    strokeDasharray: "7 8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16521",
    "data-name": "Grupo 16521",
    transform: "translate(-161 -42)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 162, 70)",
    filter: "url(#Uni\\xF3n_249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_249-2",
    "data-name": "Uni\\xF3n 249",
    d: "M7,0H25a7,7,0,0,1,7,7V24a7,7,0,0,1-7,7H7a7,7,0,0,1-7-7V7A7,7,0,0,1,7,0Z",
    transform: "translate(263 31)",
    fill: "#3f4d71"
  })), /*#__PURE__*/React.createElement("path", {
    id: "ic_call_received_24px",
    d: "M20.623,8.151,7.9,20.87V11.3H5v14.52H19.52v-2.9H9.951L22.582,10.286Z",
    transform: "translate(427 99.876)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16522",
    "data-name": "Grupo 16522",
    transform: "translate(26 59)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -25, -31)",
    filter: "url(#Uni\\xF3n_250)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_250-2",
    "data-name": "Uni\\xF3n 250",
    d: "M7,0H25a7,7,0,0,1,7,7V24a7,7,0,0,1-7,7H7a7,7,0,0,1-7-7V7A7,7,0,0,1,7,0Z",
    transform: "translate(57 62) rotate(180)",
    fill: "#42b883"
  })), /*#__PURE__*/React.createElement("path", {
    id: "ic_call_received_24px-2",
    "data-name": "ic_call_received_24px",
    d: "M6.959,25.821,19.678,13.1V22.67h2.9V8.151H8.062v2.9h9.569L5,23.685Z",
    transform: "translate(2.418 -1.848)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16527",
    "data-name": "Grupo 16527",
    transform: "translate(20254.5 6490)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -20253.5, -6462)",
    filter: "url(#Uni\\xF3n_251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_251-2",
    "data-name": "Uni\\xF3n 251",
    d: "M39.5-45.2A37.5,37.5,0,0,1,77-7.7,37.5,37.5,0,0,1,39.5,29.8,37.5,37.5,0,0,1,2-7.7,37.5,37.5,0,0,1,39.5-45.2Z",
    transform: "translate(121 61.2)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "handshake_FILL0_wght400_GRAD0_opsz48",
    d: "M23.75,41a1.632,1.632,0,0,0,.575-.125,1.483,1.483,0,0,0,.525-.325L41.7,23.65a4.3,4.3,0,0,0,.975-1.475A4.535,4.535,0,0,0,43,20.5a4.731,4.731,0,0,0-.325-1.7,4.243,4.243,0,0,0-.975-1.5l-9-9a4.243,4.243,0,0,0-1.5-.975A4.731,4.731,0,0,0,29.5,7a4.535,4.535,0,0,0-1.675.325A4.3,4.3,0,0,0,26.35,8.3l-.9.9,4.05,4.1a7.877,7.877,0,0,1,1.15,1.625,4.19,4.19,0,0,1,.5,2.025,4.564,4.564,0,0,1-1.475,3.35A4.683,4.683,0,0,1,26.3,21.75a5.022,5.022,0,0,1-2.075-.375A5.2,5.2,0,0,1,22.7,20.3l-3.65-3.65L10,25.7a1.449,1.449,0,0,0-.35.525,1.669,1.669,0,0,0-.1.575,1.454,1.454,0,0,0,1.5,1.5,1.185,1.185,0,0,0,.575-.15,2.063,2.063,0,0,0,.475-.35L19,20.9,21.1,23l-6.85,6.85a1.4,1.4,0,0,0-.35.55,1.888,1.888,0,0,0-.1.6,1.538,1.538,0,0,0,1.5,1.5,1.374,1.374,0,0,0,.575-.125,1.6,1.6,0,0,0,.475-.325l6.9-6.9,2.1,2.1L18.5,34.1a1.483,1.483,0,0,0-.325.525,1.738,1.738,0,0,0-.125.625,1.538,1.538,0,0,0,1.5,1.5,1.468,1.468,0,0,0,.55-.1,1.524,1.524,0,0,0,.5-.35l6.9-6.9,2.1,2.1-6.9,6.9a1.4,1.4,0,0,0-.35.55,1.752,1.752,0,0,0-.1.55,1.384,1.384,0,0,0,1.5,1.5Zm0,3a4.187,4.187,0,0,1-2.95-1.225,4.977,4.977,0,0,1-1.55-3.025A4.917,4.917,0,0,1,15,35.5a4.749,4.749,0,0,1-2.825-1.425A5.086,5.086,0,0,1,10.8,31.25a5.024,5.024,0,0,1-3.05-1.5,4.178,4.178,0,0,1-1.2-3,4.731,4.731,0,0,1,.325-1.7,4.243,4.243,0,0,1,.975-1.5l11.2-11.2,5.5,5.5a3.13,3.13,0,0,0,.875.625,2.153,2.153,0,0,0,.925.225,1.992,1.992,0,0,0,1.8-1.8,1.622,1.622,0,0,0-.175-.675,2.811,2.811,0,0,0-.575-.775L20.25,8.3a4.243,4.243,0,0,0-1.5-.975A4.731,4.731,0,0,0,17.05,7a4.535,4.535,0,0,0-1.675.325A4.3,4.3,0,0,0,13.9,8.3L6.3,15.9a3.989,3.989,0,0,0-.975,1.475A6.1,6.1,0,0,0,5,19.1a4.062,4.062,0,0,0,.375,1.925A8.042,8.042,0,0,0,6.4,22.7L4.25,24.85A8.768,8.768,0,0,1,2.625,22.2,8.357,8.357,0,0,1,2,19.05a7.379,7.379,0,0,1,.575-2.875A7.475,7.475,0,0,1,4.2,13.75L11.75,6.2a6.966,6.966,0,0,1,2.5-1.625A8.058,8.058,0,0,1,17.1,4.05a7.857,7.857,0,0,1,2.825.525A7.017,7.017,0,0,1,22.4,6.2l.9.9.9-.9a6.966,6.966,0,0,1,2.5-1.625,8.058,8.058,0,0,1,2.85-.525,7.857,7.857,0,0,1,2.825.525A7.017,7.017,0,0,1,34.85,6.2l8.95,8.95a7.264,7.264,0,0,1,1.65,2.5A7.734,7.734,0,0,1,46,20.5a7.542,7.542,0,0,1-.55,2.825A7.326,7.326,0,0,1,43.8,25.8L26.95,42.65a4.625,4.625,0,0,1-1.475,1A4.373,4.373,0,0,1,23.75,44ZM18.85,16.7Z",
    transform: "translate(-20116.063 -6428.769)",
    fill: "#00875a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIniciarTransaccion);
export default __webpack_public_path__ + "static/media/iniciar-transaccion.39c522cc33342081b13c83712c077ba5.svg";
export { ForwardRef as ReactComponent };